// บทความจากหลังบ้าน: POST /api/v1/getblog
//   รายการ: { System, Type: 1 }        -> [{ id, Headername, HeaderPic, Detail, tag }]
//   บทความเดียว: { System, id, Type: 2 } -> [{ ... }]
// ถ้าหลังบ้านยังไม่มีบทความ จะแสดงหน้าที่ clone มาจากเว็บตัวอย่างแทน (fallback)
import React, { useEffect, useState } from 'react';
import instance from '../axios-instance';
import Systems from '../SystemFunction';
import { useLang } from './i18n';
import SitePage from './SitePage';
import { navigate } from './nav';
import './site.css';

const cache = { list: null, byId: {} };

function parseTags(tag) {
  if (!tag) return [];
  try { const v = typeof tag === 'string' ? JSON.parse(tag) : tag; return Array.isArray(v) ? v : []; } catch (e) { return []; }
}
function stripHtml(html) {
  const d = document.createElement('div');
  d.innerHTML = html || '';
  return (d.textContent || '').replace(/\s+/g, ' ').trim();
}
function articleIdFromPath() {
  const seg = window.location.pathname.split('/').filter(Boolean);
  return seg[0] === 'article' && seg[1] ? decodeURIComponent(seg[1]) : null;
}

export async function fetchArticles() {
  if (cache.list) return cache.list;
  const res = await instance.post('/api/v1/getblog', { System: Systems, Type: 1 });
  const list = res.data.status === 200 && Array.isArray(res.data.message) ? res.data.message : [];
  cache.list = list;
  return list;
}
async function fetchArticle(id) {
  if (cache.byId[id]) return cache.byId[id];
  const fromList = (cache.list || []).find((a) => String(a.id) === String(id));
  const res = await instance.post('/api/v1/getblog', { System: Systems, id, Type: 2 });
  const item = res.data.status === 200 && Array.isArray(res.data.message) ? res.data.message[0] : fromList;
  if (item) cache.byId[id] = item;
  return item || null;
}

export default function Articles({ page }) {
  const { t } = useLang();
  const [id, setId] = useState(articleIdFromPath);
  const [list, setList] = useState(cache.list);
  const [item, setItem] = useState(null);
  const [state, setState] = useState('loading'); // loading | ok | empty

  useEffect(() => {
    const onPop = () => setId(articleIdFromPath());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  useEffect(() => {
    let alive = true;
    if (id) {
      setState('loading');
      fetchArticle(id).then((a) => { if (!alive) return; setItem(a); setState(a ? 'ok' : 'empty'); })
        .catch(() => alive && setState('empty'));
    } else {
      fetchArticles().then((l) => { if (!alive) return; setList(l); setState(l.length ? 'ok' : 'empty'); })
        .catch(() => alive && setState('empty'));
    }
    return () => { alive = false; };
  }, [id]);

  // หลังบ้านยังไม่มีบทความ -> ใช้หน้าที่ clone มา
  if (state === 'empty' && !id) return <SitePage page={page} />;

  if (state === 'loading') {
    return <div className="art-wrap"><div className="art-empty">{t('article.loading')}</div></div>;
  }

  if (id) {
    if (!item) {
      return (
        <div className="art-wrap">
          <div className="art-empty">{t('article.not_found')}</div>
          <button type="button" className="art-back" onClick={() => navigate('/article')}>‹ {t('article.back')}</button>
        </div>
      );
    }
    const tags = parseTags(item.tag);
    return (
      <article className="art-wrap art-detail">
        <button type="button" className="art-back" onClick={() => navigate('/article')}>‹ {t('article.back')}</button>
        <h1 className="art-title">{item.Headername}</h1>
        {item.HeaderPic && <img className="art-cover" src={item.HeaderPic} alt={item.Headername || ''} />}
        <div className="art-body" dangerouslySetInnerHTML={{ __html: item.Detail || '' }} />
        {tags.length > 0 && (
          <div className="art-tags">{tags.map((tg, i) => <span key={i} className="art-tag">#{tg}</span>)}</div>
        )}
      </article>
    );
  }

  return (
    <section className="art-wrap">
      <h2 className="gl-titlebar">{t('nav.article')}</h2>
      <div className="art-grid">
        {(list || []).map((a) => (
          <a key={a.id} className="art-card" href={'/article/' + encodeURIComponent(a.id)}>
            {a.HeaderPic && <img src={a.HeaderPic} alt={a.Headername || ''} loading="lazy" />}
            <div className="art-card-body">
              <h3>{a.Headername}</h3>
              <p>{stripHtml(a.Detail).slice(0, 110)}{stripHtml(a.Detail).length > 110 ? '…' : ''}</p>
              <span className="art-more">{t('article.read_more')} ›</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
